import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

@Component({ className: 'js-sticky-footer' })
export class StickyFooter {
	private defaultOffset: number;
	private footer: HTMLElement;

	constructor(private element: HTMLElement) {
		this.footer = document.querySelector('footer') as HTMLElement;
		this.defaultOffset = parseFloat(window.getComputedStyle(this.element).marginBottom);

		window.addEventListener('scroll', () => this.setPos());
		window.addEventListener('resize', () => {
			debounce(() => this.setPos(), 300);
		});
	}

	private setPos() {
		const documentHeight = document.body.clientHeight;
		const scrollBottom = window.scrollY + window.innerHeight;
		const footerHeight = this.footer.clientHeight;
		let offset = (scrollBottom) - (documentHeight - footerHeight + this.defaultOffset);
		if (offset < 0) {
			offset = 0;
		}
		this.element.style.bottom = offset + 'px';
	}
}
